module.exports = __webpack_public_path__ + "img/people3.33997147.png";